<div class="notification-background"
     adaptTooltip="Recent activities{{unreadCountText ? ' (' + unreadCountText + ' unread)' : ''}}">
    <i class="notification-bell fas fa-bell"></i>
    <span class="notification-badge"
          *ngIf="unreadCountText">{{unreadCountText}}</span>
</div>
